import { enableActivityTracking, newTracker } from '@snowplow/browser-tracker';

function init() {
  console.log('Snowplow init');

  newTracker('sp', SNOWPLOW_COLLECTOR_URL, {
    appId: `withlocals-${ENVIRONMENT}`,
    contexts: {
      webPage: true,
      session: true,
    },
  });

  enableActivityTracking({
    minimumVisitLength: 30,
    heartbeatDelay: 10,
  });
}

export default {
  init,
};
